import { HttpContextToken } from '@angular/common/http';

export const INCLUDE_AUTH_TOKEN = new HttpContextToken<boolean>(() => false);
